/* eslint-disable no-extra-parens */
import { css } from '@emotion/react';
import { widgetStyles } from '@sitebuilder/common';

const fundListStyles = css`
    button {
        border: none;
        background: none;
    }

    .icon-button {
        background: none;
        border: none;
        cursor: pointer;
    }

    .filters {
        margin: 1rem 0;

        .row {
            display: flex;
            margin: 0.5rem 0;

            @media screen and (max-width: ${widgetStyles.themeVars['$window-max-width-mobile']}) {
                flex-direction: column;
            }
        }

        .search-input-wrapper {
            position: relative;
            width: 30%;
            margin-top: auto;
            display: flex;
            flex-direction: column;

            @media screen and (max-width: ${widgetStyles.themeVars['$window-max-width-mobile']}) {
                width: 100%;
            }

            .filter-search-input {
                position: relative;
                margin-right: 1em;
                height: 2.75em;

                @media screen and (max-width: ${widgetStyles.themeVars[
                        '$window-max-width-mobile'
                    ]}) {
                    margin-right: 0;
                }

                &::placeholder {
                    color: #747474;
                    padding-left: 1.5rem;
                }
            }

            .serach-icon {
                position: absolute;
                top: 2rem;
                left: 3rem;
                color: #c8c8c8;
                pointer-events: none;
                z-index: 2;
            }
        }

        .filter-dropdowns-container {
            width: 68%;
            @media screen and (max-width: ${widgetStyles.themeVars['$window-max-width-mobile']}) {
                width: 90%;
            }

            .filter-dropdown-wrapper {
                margin: 0 0.5rem;

                @media screen and (max-width: ${widgetStyles.themeVars[
                        '$window-max-width-mobile'
                    ]}) {
                    width: 100%;
                }
            }
        }

        .mobile.filter-dropdowns-container {
            display: none;
            transition: height ease 0.2s;
        }
        .mobile.filter-dropdowns-container.open {
            height: 100px;
        }

        .filter-dropdown-label-text {
            display: block;
            margin-bottom: 0.24em;
        }

        .filter-dropdown {
            width: 100%;
        }
    }

    .view-dropdown-wrapper {
        display: none;
        align-items: center;

        @media screen and (max-width: ${widgetStyles.themeVars['$window-max-width-mobile']}) {
            display: flex !important;
        }

        .view-dropdown {
            margin-left: 0.5em;
            width: 20em;
        }
    }

    .view-tabs-wrapper {
        display: flex;
        justify-content: space-evenly;

        @media screen and (max-width: ${widgetStyles.themeVars['$window-max-width-mobile']}) {
            display: none;
        }

        .view-tab {
            padding: 0.75em 1.75em;
            color: #0f5cab;
            cursor: pointer;

            &:hover,
            &.selected {
                background-color: #0f5cab;
                color: white;
            }
        }
    }

    .fund-list-table {
        width: 100%;
        border-collapse: collapse;

        th,
        td {
            text-align: left;
            max-width: 400px;
            overflow: hidden;
        }

        th {
            position: sticky;
            top: -1px;
            z-index: 2;
            background-color: white;
            border-top: 1px solid black;
            border-bottom: 1px solid black;
            padding: 1rem 0.5rem;

            // Borders do not appear on stickied headers b/c of border-collapse.
            // Simulate bottom border on stickied cells using ::after. Top border
            // also disappears, but it actually looks fine that way.
            &::after {
                content: '';
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                height: 100%;
                border-bottom: 1px solid black;
                // So we don't block the sort toggles
                z-index: -1;
            }
        }

        td {
            padding: 0.5rem;
            border-top: 1px solid #bababa;
            border-bottom: 1px solid #bababa;
        }

        .row--group {
            background-color: #add7ff;

            td {
                // Padding will be in the toggle
                padding: 0;
            }
        }

        .row-group-toggle {
            display: block;
            width: 100%;
            padding: 1rem 1rem;
            text-align: left;
        }

        .row-group-toggle-icon {
            width: 1rem;
        }

        // Used in table cells for positioning multiple items in one cell.
        .flex-wrapper {
            display: flex;
            justify-content: space-between;
        }

        .user-list-indicator {
            margin-right: 1rem;
        }

        .risk-indicator-cell-wrapper {
            display: flex;
            flex-wrap: nowrap;
        }

        .head-cell-wrapper {
            display: flex;
            flex-wrap: nowrap;
        }

        .document-links-wrapper {
            display: flex;
            flex-wrap: wrap;
        }

        .column-icon {
            border: none;
            background: transparent;
            padding: 0em;
        }
    }

    .placeholder-functions-wrapper {
        display: flex;
        justify-content: space-between;
        width: 100%;
        align-items: center;
    }

    .functions-container {
        display: flex;
        justify-content: space-between;
        gap: 10px;
        align-items: center;
    }

    .email-container {
        a {
            background-color: #000000;
            color: #ffffff;
            padding: 15px 25px;
            text-decoration: none;
        }
    }

    .copy-container {
        button {
            background-color: #000000;
            color: #ffffff;
            padding: 12px 25px;
            text-decoration: none;
            height: auto;
            border: none;
        }
    }

    @media screen and (max-width: ${(widgetStyles.themeVars as { [k: string]: string })[
            '$window-max-width-mobile'
        ]}) {
        .fund-list-table {
            thead {
                display: none;
            }

            tbody tr {
                border-top: 1px solid #bababa;
                border-bottom: 1px solid #bababa;
            }

            td {
                // Each cell is now a full-width row, fun!
                display: flex;
                flex-direction: row;
                align-items: baseline;
                width: 100%;
                border: none;
                margin: 0.5rem;
                padding: 0;
            }

            .row--group td {
                // Margin/padding for group row cells are handled by the button toggle
                margin: 0;
            }

            .col--name {
                border-right: none;
                margin-top: 1.5rem;
            }

            tbody .col--collapsible {
                // Display column headings inline
                &::before {
                    content: attr(data-label);
                    // Display generated labels as a 30% wide column
                    display: block;
                    width: 30%;
                    // Prevent labels from shrinking
                    flex-shrink: 0;
                }

                // Add extra whitespace under last row in this card
                &:last-child {
                    margin-bottom: 2rem;
                }
            }

            .flex-wrapper {
                flex-direction: column;
                justify-content: flex-start;
            }
        }
    }
`;

export const themeFundListStyles = css`
    font-family: var(--font-family-regular);
    font-weight: var(--font-weight-regular);
    font-size: var(--font-size-regular);
    color: var(--default-text-color);
    background-color: var(--default-background-color);

    .placeholder-functions-wrapper {
        display: flex;
        justify-content: space-between;
        width: 100%;
        align-items: center;
        gap: 10px;
    }

    .functions-container {
        display: flex;
        justify-content: space-between;
        gap: 10px;
        align-items: center;
    }

    .email-container {
        a {
            background-color: var(--color-black);
            color: var(--color-white);
            padding: 15px 25px;
            text-decoration: none;
        }
    }

    .copy-container {
        button {
            background-color: var(--color-black);
            color: var(--color-white);
            padding: 12px 25px;
            text-decoration: none;
            height: auto;
            border: none;
        }
    }

    .filters {
        background-color: var(--color-grey);
        padding: 0.1rem 0rem 1rem;

        .search-input-wrapper {
            width: auto;
            margin-top: auto;
            display: flex;
            flex-direction: column;

            .search-input-label-text {
                color: var(--default-text-color);
                font-size: var(--font-size-x-small);
                margin-left: 24px;
            }

            .filter-search-input {
                margin-right: 1em;
                display: flex;
                margin-right: 8px;
                margin-left: 24px;
                padding-left: 8px;
                align-items: center;
                background-color: var(--color-white);
                border: none;
            }
        }

        .filter-dropdowns-container {
            width: auto;

            .filter-dropdown-wrapper {
                margin: 0 0.5rem;
            }

            #dropdown-assetClass-label {
                .filter-dropdown {
                    width: 15em;
                }
            }
        }

        .filter-dropdown-label-text {
            display: block;
            color: var(--default-text-color);
            font-size: var(--font-size-x-small);
        }

        .filter-dropdown {
            width: 100%;
            max-width: 15em;

            > div {
                border: none;
            }

            .dropdown__indicator {
                color: var(--default-text-color);
            }

            .dropdown__placeholder {
                color: var(--default-text-color);
            }
        }
    }

    .view-tabs-wrapper {
        position: sticky;
        top: 0;
        z-index: 99;
        width: 100%;
        display: flex;
        flex-direction: row;
        top: 0;
        background-color: var(--color-light-grey);
        justify-content: flex-start;

        @media screen and (max-width: ${widgetStyles.themeVars['$window-max-width-mobile']}) {
            display: none;
        }

        .view-tab {
            padding: 0.4rem 2rem;
            font-size: var(--body-fontSize);
            color: var(--default-text-color);

            &:hover,
            &.selected {
                background-color: var(--color-grey);
                color: var(--color-white);
            }
        }
    }

    .fund-list-table {
        width: var(--tableComponent-tableWidth);

        th {
            border-style: var(--tableComponent-thBorderStyle);
            border-color: var(--tableComponent-thBorderColor);
            border-width: var(--tableComponent-thBorderWidth);
            font-family: var(--tableComponent-thFontFamily);
            color: var(--tableComponent-thTextColor);
            font-weight: var(--tableComponent-thFontWeight);
            font-size: var(--tableComponent-thFontSize);
            line-height: var(--tableComponent-thLineHeight);
            padding: var(--tableComponent-thPadding);
        }

        td {
            border-style: var(--tableComponent-tdBorderStyle);
            border-color: var(--tableComponent-tdBorderColor);
            border-width: var(--tableComponent-tdBorderWidth);
            font-family: var(--tableComponent-tdFontFamily);
            color: var(--tableComponent-tdTextColor);
            font-weight: var(--tableComponent-tdFontWeight);
            font-size: var(--tableComponent-tdFontSize);
            line-height: var(--tableComponent-tdLineHeight);
            padding: var(--tableComponent-tdPadding);
        }

        tbody {
            .row--item:nth-child(odd) {
                background-color: var(--tableComponent-alternatedRowsBGColor);
            }

            .row--group {
                background-color: var(--color-grey);
            }
        }

        tr:last-child {
            td {
                border: none;
            }
        }

        .hide-row {
            display: none;
        }

        .show-all {
            display: table-row;
        }
    }
`;

export default fundListStyles;
